export const MODULE_FILES = '/module-files'
export const POLICY_FILES = '/policy-files'
export const STUDENT_FILES = '/student-files'
